import { saveAsFile } from "../../misc/saveAsFile";
import { useState } from "react";

export interface DownloadFileProps<T = unknown> {
  readonly apiDefinition: (key?: string, value?: T) => Promise<Blob>;
  readonly onError: (error: unknown) => void;
  readonly filename: string | ((key?: string, value?: T) => string);
}

interface DownloadedFileInfo<T> {
  readonly download: (key?: string, value?: T) => Promise<void>;
  readonly isLoading: boolean;
}

export const useDownloadFile = <T>({
  apiDefinition,
  onError,
  filename,
}: DownloadFileProps<T>): DownloadedFileInfo<T> => {
  const [loading, setLoading] = useState(false);
  const download = async (key?: string, value?: T) => {
    try {
      setLoading(true);
      const data = await apiDefinition(key, value);
      saveAsFile(data, typeof filename === "function" ? filename(key, value) : filename);
    } catch (error) {
      onError(error);
    } finally {
      setLoading(false);
    }
  };

  return { download, isLoading: loading };
};
